import { render } from "./Benutzerverwaltung.vue?vue&type=template&id=254c52fd"
import script from "./Benutzerverwaltung.vue?vue&type=script&lang=js"
export * from "./Benutzerverwaltung.vue?vue&type=script&lang=js"

import "./Benutzerverwaltung.vue?vue&type=style&index=0&id=254c52fd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__